module.exports = __webpack_public_path__ + "img/newpos.930219fc.png";